import { getAuthAxiosBackend } from "@/helpers/axios"

class PersonServices{

    get(id){
        return getAuthAxiosBackend().get('Person/person-with-residence/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('Person/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('Person/addPerson', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().patch('Person/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('Person/softDeletePerson/' + id.toString())
    }
}

export { PersonServices };
export default new PersonServices();